import request from "@/utils/request"
const platform = localStorage.getItem('platform')

export function storeOrUpdateAtpFeed(data) {
    const method = data.id ? 'put' : 'post'
    const url = data.id ? `/${platform}/title/${data.id}` : `/${platform}/title`;
    return request[method](url, data)
}

export function deleteTitle(data) {
    return request.post(`/${platform}/title/destroy`, data)
}